"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _component = require("../component");

var _func = require("../utils/func");

var _styles = require("../styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = (0, _func.curry)(function (options, Origin) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inheritsLoose(_class, _Component);

    function _class(props) {
      var _this;

      _this = _Component.call(this, props) || this;
      _this.el = null;
      _this.state = {
        focus: props.autoFocus
      };
      _this.bindRef = _this.bindRef.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.handleBlur = _this.handleBlur.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.handleFocus = _this.handleFocus.bind(_assertThisInitialized(_assertThisInitialized(_this))); // this.enterPress = this.enterPress.bind(this)

      return _this;
    }

    var _proto = _class.prototype;

    _proto.bindRef = function bindRef(el) {
      this.el = el;
    };

    _proto.handleBlur = function handleBlur(event) {
      this.setState({
        focus: false
      });
      var onBlur = this.props.onBlur;
      if (onBlur) onBlur(event);
    };

    _proto.handleFocus = function handleFocus(event) {
      this.setState({
        focus: true
      });
      var onFocus = this.props.onFocus;
      if (onFocus) onFocus(event);
    };

    _proto.renderHelp = function renderHelp(focus) {
      var _this$props = this.props,
          error = _this$props.error,
          tip = _this$props.tip,
          popover = _this$props.popover;
      var classList = ['tip', popover || 'bottom-left'];

      if (error && popover) {
        classList.push('error');
        return _react.default.createElement("div", {
          className: _styles.inputClass.apply(void 0, classList)
        }, error.message);
      }

      if (!tip || !focus) return null;
      return _react.default.createElement("div", {
        className: (0, _styles.inputClass)([].concat(classList))
      }, tip);
    };

    _proto.render = function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          border = _this$props2.border,
          size = _this$props2.size,
          tip = _this$props2.tip,
          popover = _this$props2.popover,
          width = _this$props2.width,
          style = _this$props2.style,
          error = _this$props2.error,
          other = _objectWithoutPropertiesLoose(_this$props2, ["className", "border", "size", "tip", "popover", "width", "style", "error"]);

      var focus = this.state.focus;
      var Tag = options.tag || 'label';
      var newStyle = Object.assign({
        width: width
      }, style);
      var newClassName = (0, _classnames.default)((0, _styles.inputClass)('_', focus && other.disabled !== true && 'focus', other.disabled === true && 'disabled', options.isGroup && 'group', size, newStyle.width && 'inline', !border && 'no-border', options.overflow && "overflow-" + options.overflow, error && 'invalid', popover && error && 'focus'), (0, _styles.buttonClass)(options.isGroup && 'group'), typeof options.className === 'function' ? options.className(this.props) : options.className, this.props.className);
      return _react.default.createElement(Tag, {
        ref: this.bindRef,
        className: newClassName,
        style: newStyle,
        tabIndex: options.enterPress ? '0' : undefined
      }, _react.default.createElement(Origin, _extends({}, other, {
        size: size,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur
      })), this.renderHelp(focus));
    };

    return _class;
  }(_component.Component), _defineProperty(_class, "propTypes", {
    autoFocus: _propTypes.default.bool,
    border: _propTypes.default.bool,
    className: _propTypes.default.string,
    disabled: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.func]),
    error: _propTypes.default.object,
    onBlur: _propTypes.default.func,
    onFocus: _propTypes.default.func,
    size: _propTypes.default.string,
    style: _propTypes.default.object,
    tip: _propTypes.default.any,
    width: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
    popover: _propTypes.default.oneOf(['top-left', 'top', 'top-right', 'bottom-left', 'bottom', 'bottom-right'])
  }), _defineProperty(_class, "defaultProps", {
    border: true,
    style: {}
  }), _temp;
});

exports.default = _default;